import { render } from "./InserimentoTimesheet.vue?vue&type=template&id=6c23f33b&ts=true"
import script from "./InserimentoTimesheet.vue?vue&type=script&lang=ts"
export * from "./InserimentoTimesheet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__